import Layout from '../components/Layout';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';
import { Shield, ArrowRight } from 'lucide-react';

export default function AdminLoginPage() {
  const [form, setForm] = useState({ identifier: 'admin@connectnearme.in', password: '' });
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login({ identifier: form.identifier, password: form.password, role: 'admin' });
      toast({ title: `Welcome, ${u.name}` });
      navigate('/admin');
    } catch (err) {
      toast({ title: 'Login failed', description: err.response?.data?.detail || 'Invalid credentials.' });
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="py-16">
        <div className="max-w-md mx-auto px-6">
          <div className="card-soft p-8">
            <div className="w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center mb-5"><Shield size={20} /></div>
            <h1 className="h-display text-3xl">Admin login</h1>
            <p className="text-sm text-neutral-500 mt-1">Restricted access. Log in with admin credentials.</p>

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div><label className="text-xs font-medium">Email or phone</label><input data-testid="admin-login-identifier" value={form.identifier} onChange={(e) => setForm({ ...form, identifier: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <div><label className="text-xs font-medium">Password</label><input data-testid="admin-login-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <button data-testid="admin-login-submit" disabled={busy} type="submit" className="btn-primary w-full justify-center disabled:opacity-60">{busy ? 'Logging in…' : 'Login'} <ArrowRight size={16} /></button>
            </form>

            <div className="mt-6 text-xs text-neutral-500 bg-navy/5 rounded-lg p-3">
              <p className="font-semibold text-navy">Default seeded credentials:</p>
              <p>Email: <code className="font-mono">admin@connectnearme.in</code></p>
              <p>Password: <code className="font-mono">admin@1234</code></p>
              <p className="mt-1 text-neutral-400">Change these in production!</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
